<template>
	<!-- 关于我们 -->
	<div class="about">
		<!-- top -->
		<headers/>
		<!-- 内容 -->
		<div class="common">
			<div class="banner">
				<div class="bannerCont">
					<p class="p1">卓越品质  专业才安心</p>
					<p class="p2">SUPERIOR QUALITY BRINGS PLEASURE</p>
				</div>
			</div>
			<!-- 位置 -->
			<div class="public site">
				<span class="square"></span>
				<p>您的位置： 首页  <span>></span>  项目案例</p>
			</div>
			<!-- 产品展示 -->
			<div class="contact">
				<p class="contactP">项目案例</p>
				<p class="contactP2">Project case</p>
				<div class="contactList public">
					<!-- 案例展示 -->
					<div class="case">
						<ul>
							<li v-for="(tab,index) in tabs" @click="toggle(index,tab.view)" :class="{active:active==index}" :key="index">
								{{tab.type}}
							</li>
						</ul>
						<!--:is实现多个组件实现同一个挂载点-->
						<component :is="currentView"></component>
					</div>
				</div>
			</div>
		</div>
		<!-- bottom -->
		<footers></footers>
	</div>
</template>

<script>
	import headers from '@/components/header.vue'
	import footers from '@/components/footer.vue'
	import tab1 from '@/components/case/ProjectCase.vue'
	import tab2 from '@/components/case/ProjectCase2.vue'
	import tab3 from '@/components/case/ProjectCase3.vue'
	import tab4 from '@/components/case/ProjectCase4.vue'
	import tab5 from '@/components/case/ProjectCase5.vue'
	import tab6 from '@/components/case/ProjectCase6.vue'
	import tab7 from '@/components/case/ProjectCase7.vue'
	export default{
		data(){
			return{
				active:0,
				currentView:'tab1',
				tabs:[
					{
					  type:'商业综合体',
					  view:'tab1'
					},
					{
					  type:'写字楼',
					  view:'tab2'
					},
					{
					  type:'市政',
					  view:'tab3'
					},
					{
					  type:'医院',
					  view:'tab4'
					},
					{
					  type:'小区',
					  view:'tab5'
					},
					{
					  type:'景点',
					  view:'tab6'
					},
					{
					  type:'火车站',
					  view:'tab7'
					}
				]
			}
		},
		methods:{
		    toggle(i,v){
				this.active=i;
				this.currentView=v;
		    }
		},
		components:{
			headers,footers,
			tab1,tab2,tab3,tab4,tab5,tab6,tab7
		}
	}
</script>
<style>

</style>
<style lang="scss" scoped="scoped">
	.banner{
		width: 100%;
		height:540px;
		margin: 0 auto;
		vertical-align: middle;
		position: relative;
		background: url(../../assets/images/caseBack.jpg) center no-repeat;
		background-size: 100% 100%;
		text-align: center;
		.bannerCont{
			width:600px;
			height: 380px;
			padding-top: 200px;
			color: #fff;
			margin: 0 auto;
			text-align:center;
			.p1{
				width: 600px;
				border-top:1px solid #fff ;
				font-size: 40px;
				padding: 10px;
				font-weight: bold;
			}
			.p2{
				width: 600px;
				font-size:12px;
				padding: 10px;
				border-bottom:1px solid #fff ;
			}
		}
	}
	.public{
		width: 1200px;
		margin: 0 auto;
	}
	.site{
		height: 36px;
		display: flex;
		flex-direction: row;
		align-items: center;
		text-align: left;
		font-size:16px;
		color:#333;
		margin: 30px auto;
		border-bottom:1px dashed #ccc;
		.square{
			display: inline-block;
			width: 10px;
			height: 20px;
			background: #000;
			margin-right: 10px;
		}
		p{
			span{
				padding: 0 5px;
			}
		}
	}
	.contact{
		.contactP{
			margin-top: 20px;
			padding: 10px 0;
			font-size: 28px;
			font-weight: bold;
		}
		.contactP2{
			margin-bottom: 20px;
			text-transform:uppercase;
		}
		.contactList{
			display: flex;
			flex-direction: row;
			.case{
				ul{
					width:1200px;
					margin: 0 auto;
					display:flex;
					text-align: center;
					flex-direction: row;
					align-items: center;
					justify-content: center;
					li{
						height:36px;
						padding: 0 15px;
						display: inline-flex;
						justify-content: center;
						align-items: center;
						cursor:pointer;
						position: relative;
					}
					li.active{
						color: #fff;
						background:#3c77f0 ;
						border-radius:5px;
					}
				}
			}
		}
	}
</style>



// WEBPACK FOOTER //
// src/views/case/case.vue